import { CartUpdateResult, type LineItem } from "@app/scripts/types";
import React, { useCallback, useEffect, useState } from "react";

type Props = {
  lineItem: LineItem;
  onQtyChange: (value: number) => Promise<CartUpdateResult>;
  oos?: boolean;
  isKid?: boolean;
};

export const CartQty: React.FC<Props> = ({ lineItem, onQtyChange, oos, isKid }) => {
  const [value, setValue] = useState(lineItem.quantity);

  const handleChange = useCallback(
    async (newVal: number) => {
      const oldVal = value;
      setValue(newVal);
      const result = await onQtyChange(newVal);

      if (result?.error) {
        setValue(oldVal);
      }
    },
    [value, onQtyChange]
  );

  useEffect(() => {
    setValue(lineItem?.quantity);
  }, [lineItem]);

  return (
    <div className={`_field qty ${oos && isKid ? "hidden" : ""} flex-1`}>
      <input type="number" min="0" aria-label={`Quantity: ${lineItem.product_title || lineItem.title}`} value={value} onChange={(e) => { if (e.target.value !== "") handleChange(Math.max(0, parseInt(e.target.value))); }} />
      <button type="button" aria-label={`Decrease quantity: ${lineItem.product_title || lineItem.title}`} onClick={() => handleChange(Math.max(0, value - 1))}>
        <div className="qty-btn-wrap">
          <ui-icon name="icon-minus" />
        </div>
      </button>
      <button type="button" aria-label={`Increase quantity: ${lineItem.product_title || lineItem.title}`} onClick={() => handleChange(value + 1)}>
        <div className="qty-btn-wrap">
          <ui-icon name="icon-plus" />
        </div>
      </button>
    </div>
  );
};
